import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface IUserData {
  [key: string]: any;
  iss: string;
  sub: string;
  id: string;
  name: string;
  tel: string;
  weddingTsp: string;
  weddingTspType: string;
  sex: string;
  loginId: string;
  nick: string;
  imageUrl: string;
  customerUuid: string;
  tokenExpired: string;
  exp: string;
  additionalInformationRegistRequest?: string;
  customerRegTsp?: string | null;
}

export interface IUserState {
  needCallAdditionalData: boolean;
  data: IUserData;
}

const initialState: IUserState = {
  needCallAdditionalData: true,
  data: {
    additionalInformationRegistRequest: "",
    iss: "",
    sub: "",
    id: "",
    name: "",
    tel: "",
    weddingTsp: "",
    weddingTspType: "",
    sex: "",
    loginId: "",
    nick: "",
    imageUrl: "",
    customerUuid: "",
    tokenExpired: "",
    exp: "",
    customerRegTsp: null,
  },
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setNeedCallAdditionalData(state, action: PayloadAction<{ boo: boolean }>) {
      state.needCallAdditionalData = action.payload.boo;
    },
    setResetData(state) {
      Object.keys(initialState.data).forEach((key) => {
        state.data[key] = initialState.data[key as keyof typeof initialState.data];
      });
    },
    setData(state, action: PayloadAction<{ data: any }>) {
      let newData = action.payload.data;
      // 기존에 추가 정보 호출 상태라면 기존 값을 유지
      if (state.data?.additionalInformationRegistRequest) {
        newData = {
          ...newData,
          additionalInformationRegistRequest: state.data.additionalInformationRegistRequest,
          mateName: state.data.mateName,
          mateTel: state.data.mateTel,
          region: state.data.region,
          weddingTsp: state.data.weddingTsp,
          weddingTspType: state.data.weddingTspType,
          weddinghallName: state.data.weddinghallName,
        };
      }
      state.data = { ...state.data, ...newData };
    },
  },
});

export type TUserType = "GUEST_USER" | "COMPLETE_AUTH_USER";
interface userMetaState {
  userType: TUserType | null; // COMPLETE_AUTH_USER , GUEST_USER, //  null INCOMPLETE_AUTH_USER,
  needUpdateUserType: boolean | null; // true : 로그인 상태 업데이트 필요, false : 로그인 상태 업데이트 불필요, null : 초기값
}

const initialState2: userMetaState = {
  userType: null,
  needUpdateUserType: null,
};

export const userPersistSlice = createSlice({
  name: "userPersistData",
  initialState: initialState2,
  reducers: {
    setNeedUpdateUserType(state, action: PayloadAction<{ status: boolean | null }>) {
      state.needUpdateUserType = action.payload.status;
    },
    setUserType(state, action: PayloadAction<{ status: TUserType | null }>) {
      state.userType = action.payload.status;
    },
    setResetPersistData(state) {
      state.userType = null;
      state.needUpdateUserType = null;
    },
  },
});

export const { setData, setResetData, setNeedCallAdditionalData } = userSlice.actions;
export const User = (state: RootState) => state.user;
export const UserData = (state: RootState) => state.user.data;

export const { setNeedUpdateUserType, setUserType, setResetPersistData } = userPersistSlice.actions;
export const needUpdateUserType = (state: RootState) => state.userPersistData.needUpdateUserType;
export const userType = (state: RootState) => state.userPersistData.userType;
export default userSlice.reducer;
